import { FC } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { EuflexxaLogo } from "../../assets";
import { PublicHeader } from "../../constants/headerLinks";
import { HeaderElementType } from "../../types";



const GuestHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const closeMobileMenu = () => {
    const navbarCollapse = document.getElementById('hubHeader');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  return (
    <nav className="navbar navbar-expand-lg py-1">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/users/sign_in"><img src={EuflexxaLogo} alt="Euflexxa logo" /></Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#hubHeader">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-start" id="hubHeader">
          <ul className="navbar-nav">
            {PublicHeader.map((headerLink, index) => (
              <li className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`} key={index}>
                {headerLink.actionType === HeaderElementType.ROUTE ? (
                  <Link className="nav-link" aria-current="page" to={headerLink.redirectLink} onClick={closeMobileMenu}>{headerLink.title}</Link>
                ) : null}
                {headerLink.actionType === HeaderElementType.BUTTON ? (
                  <button className="btn btn-warning rounded-pill custom-text-purple" onClick={() => { closeMobileMenu(); navigate(headerLink.redirectLink) }}>
                    {headerLink.title}
                  </button>
                ) : null}
                {headerLink.actionType === HeaderElementType.LINK ? (
                  <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                    {headerLink.title}
                  </a>
                ) : null}
                {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                  <>
                    <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown" aria-expanded="false" onClick={closeMobileMenu}>
                      {headerLink.title}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end" style={{ top: '53px' }}>
                      {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                        <li key={index}>
                          <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                            {header.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default GuestHeader;
